
import { Component, OnInit, AfterViewInit} from '@angular/core';
import { Attending } from '../../model/attending';
import { Observable } from 'rxjs/Observable';
import { NgRedux } from '@angular-redux/store';
import { ArgosState } from '../../../core/argos-state';
import { UPDATE_ATTENDING_FILTER } from '../../../core/actions';
import { DatePipe } from '../../../shared/pipe/date.pipe';
import { Mask } from '../../../shared/pipe/interface/mask';
import { Router } from '@angular/router';
import { AttendingService } from '../../service/attending.service';
import { StepAlias } from '../../model/step-alias';
import { StepColoring } from '../../model/step-coloring';
import * as moment from 'moment';
import { PageInfo } from '../../../shared/model/page-info';
import attendingStatus from '../../model/attending-status';
import { AuthenticationService } from '../../../shared/service/authentication.service';
import { Monitoring } from '../../model/monitoring';
import { AttendingTypeService } from './../../../shared/service/attending-type.service';

@Component({
  selector: 'tx-attending-list',
  templateUrl: './attending-list.component.html',
  styleUrls: ['./attending-list.component.css']
})
export class AttendingListComponent implements OnInit, AfterViewInit {
  attendings: Array<Attending>;
  pageNumber = 0;
  pageSize = 15;
  pageInfo: PageInfo;
  authenticatedUser: any;

  filterField = ['attendingFilter'];
  idFilter = ['attendingId'];
  customerFilter = ['customerName'];
  branchFilter = ['branchName'];
  autoEletricFilter = ['autoEletricName'];
  currentStepFilter = ['currentStep'];
  jiraTicketFilter = ['jiraTicket'];
  vehiclePlateFilter = ['vehiclePlate'];
  statusFilter = ['status'];
  monitoringUserFilter = ['monitoringUser'];
  scheduleDateFilter = ['scheduleDate'];
  filter = [];
  filterIsOpened = false;
  filterLabel = '';
  filterOptions = { };
  maxChar: number;
  mask: Mask;
  filterActionType = UPDATE_ATTENDING_FILTER;
  inputTypeFilter = 'text';
  attendingFilter$: Observable<any>;
  stepAliases = new StepAlias();
  stepColoring = new StepColoring();
  attendingStatus = attendingStatus;

  constructor(private _router: Router,
              private _attendingService: AttendingService,
              private _ngRedux: NgRedux<ArgosState>,
              private _authService: AuthenticationService,
              private _attendingTypeService: AttendingTypeService) {
    this.setEmptyEntities();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.findAttendings();
  }

  findAttendings() {
    this._attendingService.findAttendings(this.pageNumber, this.pageSize);
  }

  findByFilter() {
    this.pageNumber = 0;
    this.filterIsOpened = false;
    this.findAttendings();
  }

  openAttending(id) {
    this._router.navigate([`attendings/${id}`]);
  }

  visualizeAttending(id) {
    this._router.navigate([`attendings/check/${id}`]);
  }

  openFilter(inputType, label, filterField, mask?, maxChar?) {
    if (filterField[filterField.length - 1] === this.filter[this.filter.length - 1] && this.filterIsOpened) {
      this.filterIsOpened = false;
    } else {
      this.maxChar = maxChar;
      this.mask = mask;
      this.filter = this.filterField.concat(filterField);
      this.filterIsOpened = true;
      this.inputTypeFilter = inputType;
      this.filterLabel = label;
    }
  }

  openSelectFilter(inputType, label, filterField, optionsList) {
    this.filterOptions = optionsList;
    this.openFilter(inputType, label, filterField);
  }

  checkMonitoringUser(monitoring: Monitoring) {
    try {
      if (monitoring.argosUser.username === this.authenticatedUser.username) {
        return 'Sou Eu';
      } else {
        return monitoring.argosUser.name;
      }
    } catch (e) {
      return null;
    }
  }

  newAttending(attendingType: string) {
    this._attendingTypeService.attendingType = attendingType;
    this._router.navigate(['attendings']);
  }

  formatDate(date) {
    if (date) {
      const newDate = new Date(date);
      return moment(newDate).format('DD/MM/YYYY');
    }
  }

  goToPage(pageNumber) {
    this.pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
    this.findAttendings();
  }

  previousPage() {
    if (this.pageNumber > 0) {
      this.pageNumber = this.pageNumber - 1;
      this.findAttendings();
    }
  }

  nextPage() {
    if (this.pageNumber < this.pageInfo.lastPage - 1) {
      this.pageNumber = this.pageNumber + 1;
      this.findAttendings();
    }
  }

  canCreateAttending() {
    if (this.authenticatedUser.stepKeys
        && this.authenticatedUser.stepKeys.find(stepKey => stepKey.id === 1)) {
      return true;
    }
  }

  private setUpObservers() {
    this.attendingFilter$ = this._ngRedux.select('attendingFilter');

    this._attendingService.find$
      .subscribe(attendings => {
        this.attendings = this.cleanAttendings(attendings);
      });

    this.setUpPageInfo();
  }

  private cleanAttendings(attendings) {
    try {
      return attendings.filter((attending) => attending.currentStep !== 'SCREENING');
    } catch (e) {
      return [];
    }
  }

  private setEmptyEntities() {
    this.authenticatedUser = this._authService.getUserFromLocalStorage();
    this.mask = new DatePipe();
    this.attendings = new Array();
  }

  private setUpPageInfo() {
    this._attendingService.pageInfo$
      .subscribe(pageInfo => this.pageInfo = pageInfo);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/attending-list/attending-list.component.ts